"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutSelection = void 0;
var layout_page_1 = require("../main-structures/layout-page");
var layout_selection_info_1 = require("./layout-selection-info");
var LayoutSelection = (function () {
    function LayoutSelection(subDocumentInfo, pageIndex, innerClientProperties) {
        this.subDocumentInfo = null;
        this.pageIndex = -1;
        this.firstPageIndexWithSelection = 0;
        this.lastPageIndexWithSelection = 0;
        this.selectionInfo = new layout_selection_info_1.LayoutSelectionInfo(layout_page_1.LayoutPageFlags.IsSelectionRendered, innerClientProperties);
        this.searchInfo = new layout_selection_info_1.LayoutSelectionInfo(layout_page_1.LayoutPageFlags.IsSearchSelectionRendered, innerClientProperties);
        this.misspelledInfo = new layout_selection_info_1.LayoutSelectionInfo(layout_page_1.LayoutPageFlags.IsMisspelledSelectionRendered, innerClientProperties);
        this.rangePermissionInfo = new layout_selection_info_1.LayoutSelectionInfo(layout_page_1.LayoutPageFlags.IsRangePermissionsRendered, innerClientProperties);
        this.subDocumentInfo = subDocumentInfo;
        this.pageIndex = pageIndex;
    }
    LayoutSelection.prototype.updatePageIndexWithSelection = function () {
        this.firstPageIndexWithSelection = -1;
        this.lastPageIndexWithSelection = 0;
        for (var pageIndex = 0, pageInfo = void 0; pageInfo = this.selectionInfo.pageInfos[pageIndex]; pageIndex++) {
            if (pageInfo.oldItems.length) {
                if (this.firstPageIndexWithSelection < 0)
                    this.firstPageIndexWithSelection = pageIndex;
                this.lastPageIndexWithSelection = pageIndex;
            }
        }
    };
    return LayoutSelection;
}());
exports.LayoutSelection = LayoutSelection;
